var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "dashboard-thread-list-item",
      attrs: {
        href: "#drawer-messages-chat",
        "data-toggle": _vm.$chatsModuleEnabled ? "drawer" : null,
        "aria-foldedopen": "false",
        "aria-controls": "drawer-messages-chat",
      },
      on: { click: _vm.handleGetThreadCallback },
    },
    [
      _c("a", [
        _c("div", { staticClass: "row booking-thread-list-item" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-1 participants-container" },
            _vm._l(_vm.participantsAvatars, function (p, index) {
              return _c("img", {
                key: p.id,
                style: {
                  left: index * 15 + "px",
                  "z-index": _vm.participantsAvatars.length - index,
                },
                attrs: { src: p.avatar },
              })
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-sm-7" }, [
            _c("h3", { staticClass: "chat-lead" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.participantsNames) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _vm.$chatsModuleEnabled
              ? _c("div", [
                  _vm.thread.latest_message
                    ? _c("span", [
                        _c(
                          "span",
                          {
                            class: this.thread.unread_count
                              ? "unread-messages"
                              : "chat-sub message-text",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.messageName) +
                                ": " +
                                _vm._s(
                                  _vm.thread.latest_message.file
                                    ? "File Uploaded"
                                    : _vm.thread.latest_message.text
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pull-right",
                            class: this.thread.unread_count
                              ? "unread-messages"
                              : "chat-sub message-text",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.messageTimestamp) +
                                "\n              "
                            ),
                            this.thread.unread_count && !_vm.$userIsAdmin
                              ? _c(
                                  "span",
                                  { staticClass: "unread-circle pull-right" },
                                  [
                                    _vm._v(
                                      "\n                 \n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            this.thread.unread_count && _vm.$userIsAdmin
                              ? _c("span", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                 | " +
                                      _vm._s(this.thread.unread_count) +
                                      " unread\n              "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ])
                    : _c("span", [
                        _c("span", { staticClass: "chat-sub message-text" }, [
                          _vm._v("No Messages"),
                        ]),
                      ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.$chatsModuleEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-3 messaging-flex-box spacer-y-1",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-info btn-sm pull-right thread-list-item-button w-full",
                      attrs: { type: "button" },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.threadButton) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }